import en from '@/language/en'
import ar from '@/language/ar'
import es from '@/language/es'
import pt from '@/language/pt'
import tr from '@/language/tr'
import zh from '@/language/zh'
import th from '@/language/th'
import vi from '@/language/vi'
import inAlias from '@/language/in'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'en',
  messages: {
    en,
    ar,
    es,
    pt,
    tr,
    zh,
    th,
    vi,
    in: inAlias
  },
  warnHtmlMessage: false
}))
